<div *ngIf="!props.hidden"
     class="row">
  <label *ngIf="props.label && props.hideLabel !== true"
         [attr.for]="id"
         [ngClass]="[props.labelClassName || 'col-4', 'col-form-label', 'col-form-label-sm']">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true"
          class="text-danger">*</span>
  </label>

  <div [ngClass]="[
      props.formControlClassName || 'col-8',
      showError ? 'has-error' : ''
    ]">
    <ng-template #fieldComponent></ng-template>

    <div *ngIf="showError"
         class="invalid-feedback"
         [style.display]="'block'">
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>

    <small *ngIf="props.description"
           class="form-text text-muted">{{ props.description }}</small>
  </div>
</div>